module.exports = __webpack_public_path__ + "img/ic_btn_chat_w.e99aea0c.svg";